import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "../../utils/toast";
import { initiateWhatsApp } from "../../actions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import store from "../../store";
import classes from './css/chat.module.scss';

const Chat = (props) => {
  const _reCaptchaRef = useRef(null);
  const _form = React.createRef();

  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const validator = useRef(new SimpleReactValidator());

  const [Data, setData] = useState({
    name: "",
    countryCode: "",
    mobile: "",
    email: "",
    message: "",
  });

  const clearData = () => {
    setData({
      name: "",
      countryCode: "",
      mobile: "",
      email: "",
      message: "",
    });
  };

  const toggleChat = () => {
    store.dispatch({ type: "WHATSAPP_CHAT" });
  };

  const onChangeHandler = async (event) => {
    event.persist();
    setData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleCountryCode = (value, country, e, formattedValue) => {
    setData((prevState) => ({
      ...prevState,
      countryCode: formattedValue,
      mobile: value,
    }));
  };

  const onRecaptcha = (e) => {
    e.preventDefault();
    if (validator.current.allValid()) {
      _reCaptchaRef.current.executeAsync();
      validator.current.hideMessages();
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  const handleSubmit = () => {
    _form.current.reset();

    props.initiateWhatsApp(Data);
    _reCaptchaRef.current.reset();
    validator.current.hideMessages();
    toggleChat();
    clearData();
    toast.success("WhatsApp Chat is Initiated Successfully", {
      toastId: "whatsapp-chat-initiated",
      hideProgressBar: true,
    });
  };

  // Close modal when clicking outside the modal content
  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      toggleChat();
    }
  };


  return (
    <div id="chatContainer">
      <button
        id="chatButton"
        className={`${classes.chat_button} d-none d-md-block`}
        onClick={toggleChat}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <g filter="url(#filter0_i_788_35309)">
            <path d="M0 39.7404L2.79481 29.5362C1.06821 26.5428 0.161285 23.1471 0.165456 19.6914C0.170007 8.8334 9.00609 0 19.8643 0C25.1335 0.00267728 30.0792 2.0532 33.7987 5.77542C37.5183 9.49763 39.5648 14.4452 39.5629 19.7072C39.5581 30.5643 30.7207 39.3993 19.864 39.3993H19.8555C16.5589 39.398 13.3197 38.571 10.4424 37.0021L0 39.7404Z" fill="white" />
          </g>
          <g filter="url(#filter1_i_788_35309)">
            <path d="M19.8712 3.32426C10.84 3.32426 3.49542 10.6662 3.4922 19.6905C3.48776 22.772 4.35552 25.7919 5.99519 28.401L6.38473 29.0202L4.73044 35.0596L10.9273 33.4348L11.5256 33.7893C14.0388 35.2808 16.9203 36.0695 19.8589 36.0711H19.8651C28.8894 36.0711 36.2339 28.7284 36.2374 19.7036C36.2442 17.5525 35.8243 15.4215 35.0019 13.4339C34.1796 11.4462 32.9711 9.64149 31.4464 8.12408C29.9303 6.59838 28.1265 5.38856 26.1396 4.56467C24.1528 3.74078 22.0222 3.31917 19.8712 3.32426Z" fill="url(#paint0_linear_788_35309)" />
          </g>
          <g filter="url(#filter2_i_788_35309)">
            <path fillRule="evenodd" clipRule="evenodd" d="M14.9379 11.4556C14.5689 10.6361 14.1807 10.6195 13.8303 10.6053L12.8868 10.5938C12.5586 10.5938 12.0252 10.7169 11.5744 11.2095C11.1235 11.7021 9.85156 12.8927 9.85156 15.3143C9.85156 17.7359 11.6154 20.0759 11.8611 20.4046C12.1069 20.7334 15.2661 25.8612 20.2691 27.8341C24.4267 29.4736 25.2727 29.1475 26.1754 29.0656C27.0782 28.9837 29.0875 27.875 29.4974 26.7257C29.9073 25.5763 29.9076 24.5916 29.7847 24.3857C29.6618 24.1799 29.3336 24.0575 28.8409 23.8112C28.3483 23.5649 25.9289 22.3743 25.4778 22.2099C25.0266 22.0455 24.6987 21.9639 24.3702 22.4565C24.0417 22.9491 23.0995 24.0572 22.8123 24.3857C22.525 24.7142 22.2382 24.7555 21.7456 24.5094C21.253 24.2634 19.6681 23.7435 17.7875 22.0667C16.3244 20.762 15.3368 19.1509 15.0492 18.6585C14.7617 18.1662 15.0187 17.8995 15.2656 17.6543C15.4864 17.4337 15.7576 17.0795 16.0042 16.7922C16.2508 16.5049 16.3319 16.2996 16.4958 15.9716C16.6596 15.6436 16.578 15.3556 16.4548 15.1095C16.3316 14.8635 15.3753 12.429 14.9379 11.4556Z" fill="white" />
          </g>
          <defs>
            <filter id="filter0_i_788_35309" x="0" y="0" width="39.5625" height="40.6596" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dy="0.919385" />
              <feGaussianBlur stdDeviation="0.459693" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.125904 0 0 0 0 0.612815 0 0 0 0 0.198941 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_788_35309" />
            </filter>
            <filter id="filter1_i_788_35309" x="3.49219" y="3.32422" width="32.7451" height="33.6665" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dy="0.919385" />
              <feGaussianBlur stdDeviation="0.459693" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.125904 0 0 0 0 0.612815 0 0 0 0 0.198941 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_788_35309" />
            </filter>
            <filter id="filter2_i_788_35309" x="9.85156" y="10.5938" width="20.0049" height="19.4731" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dy="0.919385" />
              <feGaussianBlur stdDeviation="0.459693" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.125904 0 0 0 0 0.612815 0 0 0 0 0.198941 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_788_35309" />
            </filter>
            <linearGradient id="paint0_linear_788_35309" x1="19.5315" y1="5.28938" x2="19.6975" y2="33.2736" gradientUnits="userSpaceOnUse">
              <stop stopColor="#57D163" />
              <stop offset="1" stopColor="#23B33A" />
            </linearGradient>
          </defs>
        </svg>
      </button>


      {props.isChatOpen && (
        <div
          id="modal-overlay"
          className={classes.modal_overlay}
          onClick={handleOverlayClick}
        >
          <div className={classes.modal_content}>
            <div className={classes.modal_header}>
              <div className={classes.header_left}>
                <div className={classes.avatar}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="#fff"
                    className="bi bi-diamond-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"
                    />
                  </svg>
                </div>
                <div className={classes.header_text}>
                  <h3>Sunny Diamonds Support</h3>
                  <span>We usually reply within minutes</span>
                </div>
              </div>
              <button
                type="button"
                className={classes.close_button}
                onClick={toggleChat}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className={classes.modal_body}>
              <form
                id="chatForm"
                ref={_form}
                onSubmit={onRecaptcha}
                className={classes.contact_form}
              >
                <div className={classes.form_intro}>
                  <p>
                    Please fill out the form below and we'll connect with you on
                    WhatsApp.
                  </p>
                </div>
                <div className={classes.form_group}>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className={`${classes.form_control} required-placeholder`}
                    placeholder="Your Name *"
                    value={Data.name}
                    onChange={onChangeHandler}
                  />
                  <div className={classes.error_message}>
                    {validator.current.message(
                      "name",
                      Data.name,
                      "required|alpha_space"
                    )}
                  </div>
                </div>

                <div className={classes.form_group}>
                  <PhoneInput
                    className={classes.phone_input}
                    id="mobile"
                    country={"in"}
                    placeholder="Mobile Number *"
                    inputClass={`${classes.form_control} required-placeholder`}
                    value={Data.mobile}
                    name="mobile"
                    onChange={handleCountryCode}
                    isValid={(value, country) => {
                      if (country.iso2 !== "in") {
                        return true;
                      }
                      const regex = /^[789]\d{11}$/;
                      if (value.length > 3 && !regex.test(value)) {
                        return "Invalid Indian phone number";
                      }
                      return true;
                    }}
                  />
                  <div className={classes.error_message}>
                    {validator.current.message(
                      "mobile",
                      Data.mobile,
                      "required|phone|min:12|max:15"
                    )}
                  </div>
                </div>

                <div className={classes.form_group}>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className={`${classes.form_control} required-placeholder`}
                    placeholder="Your Email *"
                    value={Data.email}
                    onChange={onChangeHandler}
                  />
                  <div className={classes.error_message}>
                    {validator.current.message(
                      "email",
                      Data.email,
                      "required|email"
                    )}
                  </div>
                </div>

                <div className={classes.form_group}>
                  <textarea
                    id="message"
                    name="message"
                    className={classes.form_control}
                    placeholder="Your Message"
                    value={Data.message}
                    onChange={onChangeHandler}
                    rows="3"
                  />
                </div>

                <ReCAPTCHA
                  ref={_reCaptchaRef}
                  size="invisible"
                  sitekey={global.reCaptcha}
                  onChange={handleSubmit}
                />

                <button type="submit" className={classes.submit_button}>
                  Start WhatsApp Chat
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isChatOpen: state.chat.isChatOpen,
});

export default connect(mapStateToProps, { initiateWhatsApp })(Chat);
